const PAGE_TYPES = {
    CONFIRMATION: 'confirmation',
    CHECKOUT: 'checkout',
    REDIRECT: 'redirect'
}

export default PAGE_TYPES
